// no longer used
import SERVER_URL from '@/config'

const feathers = require('feathers/client')
const socketio = require('feathers-socketio/client')
const hooks = require('feathers-hooks')
// const errors = require('feathers-errors')
const auth = require('feathers-authentication-client')
const io = require('socket.io-client/dist/socket.io')

const socket = io(SERVER_URL, {
  transports: ['websocket']
})

// socket.io.on('connect_error', function (err) {
//   console.log(err)
//   // socket.disconnect()
// })

const storage = localStorage

const feathersClient = feathers()
  .configure(socketio(socket, {
    timeout: 5 * 60 * 1000
    // timeout: 1000
  }))
  .configure(hooks())
  .configure(auth({ storage, timeout: 60 * 1000 }))

export default feathersClient
